import WashdayClientSingleton from './WashdayClientSingleton';
import type { AppReturnUrlOptions } from '../utils/domainReturnUrls';

export type StartMPOAuthFlowData = Partial<AppReturnUrlOptions> & {
    redirectUri?: string;
};

export const startMPOAuthFlow = async (data: StartMPOAuthFlowData) => {
    try {
        return await WashdayClientSingleton.getInstance().integrations.startMPOAuthFlow(data);
    } catch (e) {
        console.log('ERROR startMPOAuthFlow', e);
        throw e;
    }
}

export const getMPConnectionStatus = async () => {
    try {
        return await WashdayClientSingleton.getInstance().integrations.getMPConnectionStatus();
    } catch (e) {
        console.log('ERROR getMPConnectionStatus', e);
        throw e;
    }
}

export const disconnectMP = async () => {
    try {
        return await WashdayClientSingleton.getInstance().integrations.mercadoPago.disconnectMP();
    } catch (e) {
        console.log('ERROR disconnectMP', e);
        throw e;
    }
}

export const getDiscoverMPTerminals = async (data: {
    mp_store_id: string;
}) => {
    try {
        return await WashdayClientSingleton.getInstance().integrations.mercadoPago.getDiscoverMPTerminals(data);
    } catch (e) {
        console.log('ERROR getDiscoverMPTerminals', e);
        throw e;
    }
}

export const importMPTerminal = async (data: {
    storeId: string;
    mp_pos_id: string;
    label?: string;
    mp_store_id?: string;
}) => {
    try {
        return await WashdayClientSingleton.getInstance().integrations.mercadoPago.importMPTerminal(data);
    } catch (e) {
        console.log('ERROR importMPTerminal', e);
        throw e;
    }
}

export const getStoredMPTerminals = async (data: {
    storeId: string;
}) => {
    try {
        return await WashdayClientSingleton.getInstance().integrations.mercadoPago.getStoredMPTerminals(data);
    } catch (e) {
        console.log('ERROR getStoredMPTerminals', e);
        throw e;
    }
}

export const getMPUsersStores = async (data: {
    user_id: string;
}) => {
    try {
        return await WashdayClientSingleton.getInstance().integrations.mercadoPago.getMPUsersStores(data);
    } catch (e) {
        console.log('ERROR getMPUsersStores', e);
        throw e;
    }
}

export const importAllMPTerminals = async (data: {
    storeId: string;
}) => {
    try {
        return await WashdayClientSingleton.getInstance().integrations.mercadoPago.importAllMPTerminals(data);
    } catch (e) {
        console.log('ERROR importAllMPTerminals', e);
        throw e;
    }
}

export const createMPAttempt = async (data: {
    orderId: string;
    amount: number;
    currency: string;
    storeId: string;
    terminalId: string;
    cashierBoxId: string;
    print_on_terminal?: 'no_ticket' | 'seller_ticket';
}) => {
    try {
        return await WashdayClientSingleton.getInstance().integrations.mercadoPago.createMPAttempt(data);
    } catch (e) {
        console.log('ERROR createMPAttempt', e);
        throw e;
    }
}

export const cancelMPAttempt = async (data: {
    attemptId: string;
}) => {
    try {
        return await WashdayClientSingleton.getInstance().integrations.mercadoPago.cancelMPAttempt(data);
    } catch (e) {
        console.log('ERROR cancelMPAttempt', e);
        throw e;
    }
}

export const getMPAttemptStatus = async (data: {
    attemptId: string;
}) => {
    try {
        return await WashdayClientSingleton.getInstance().integrations.mercadoPago.getMPAttemptStatus(data);
    } catch (e) {
        console.log('ERROR getMPAttemptStatus', e);
        throw e;
    }
}

export const updateMPTerminalOperationMode = async (data: {
    storeId: string;
    mp_terminal_id: string;
    operatingMode: string;
}) => {
    try {
        return await WashdayClientSingleton.getInstance().integrations.mercadoPago.updateMPTerminalOperationMode(data);
    } catch (e) {
        console.log('ERROR updateMPTerminalOperationMode', e);
        throw e;
    }
}
